import { render, staticRenderFns } from "./NotesTable.vue?vue&type=template&id=379d4cf0&scoped=true&"
import script from "./NotesTable.vue?vue&type=script&lang=js&"
export * from "./NotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d4cf0",
  null
  
)

export default component.exports